import { AxiosClient } from '@/service/axiosClient'
import { AxiosResp } from '@/types'
import { IUser } from '@/types/interfaces/user'
import {
  IPasswordUpdateParam,
  IUserJoinParam,
  IUserSocialJoinParam,
  IUserUpdateParam,
} from './models/user'

export const userApi = {
  /** 회원가입 */
  join: (param: IUserJoinParam) => {
    return AxiosClient.post<AxiosResp<null>>(`/users`, param)
  },

  /** 소셜 회원가입(내정보 수정) */
  socialJoin: (param: IUserSocialJoinParam, token: string) => {
    return AxiosClient.put<AxiosResp<null>>(`/users/initial`, param, {
      headers: { Authorization: `Bearer ${token}` },
    })
  },

  /** 아이디 중복체크 */
  checkLoginId: (loginId: string) => {
    return AxiosClient.get<AxiosResp<boolean>>(`/users/duplicate/login-id/${loginId}`)
  },

  /** 이메일 중복체크 */
  checkEmail: (email: string) => {
    return AxiosClient.get<AxiosResp<boolean>>(`/users/duplicate/email/${email}`)
  },

  /** 닉네임 중복체크 */
  checkNickname: (nickname: string) => {
    return AxiosClient.get<AxiosResp<boolean>>(`/users/duplicate/nickname/${nickname}`)
  },

  /** 내정보 수정 */
  update: (param: IUserUpdateParam) => {
    return AxiosClient.put<AxiosResp<null>>(`/users/own`, param)
  },

  /** 회원탈퇴 */
  delete: () => {
    return AxiosClient.delete<AxiosResp<null>>(`/users/own`)
  },

  /** 내정보 조회 */
  getMe: (token?: string) => {
    return AxiosClient.get<AxiosResp<IUser>>(`/users/own`, undefined, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
  },

  /** 비밀번호 수정 */
  updatePassword: (param: IPasswordUpdateParam) => {
    return AxiosClient.patch<AxiosResp<IUser>>(`/users/own/password`, param)
  },
}
